import React, { useEffect, useState } from 'react';
import css from './CustomPrivacyPolicyPage.module.css';
import { Button, LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

const CustomPrivacyPolicyPage = props => {
  return (
    <Page title={'Modern Builder'} scrollingDisabled={false}>
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={<TopbarContainer currentPage="PrivacyPolicyPage" type="floating" />}
        footer={<FooterContainer />}
      >
        <div className={css.content}>
        <center>
          {' '}
          <h3>PRIVACY NOTICE</h3>
        </center>

        <p>
          <strong>Who we are you</strong>
        </p>
        <p>
          We are The Modern Builder Limited, a company registered in England and Wales (company
          number 15098660) with registered office at 81 King Street, c/o Accounts and Legal,
          Manchester, England, M2 4AH (&ldquo;<strong>The Modern Builder</strong>&rdquo;, "
          <strong>we</strong>", "<strong>us</strong>" or "<strong>our</strong>").
        </p>
        <ul>
          <li>
            <strong>About this Privacy Notice</strong>
          </li>
        </ul>
        <p>
          We respect your privacy and are committed to protecting your personal data. Our privacy
          notice gives you information about how The Modern Builder collects and uses personal data
          through the use of our website, including any data you may provide us when you register
          with us, become our customer or we provide you with a service. We are committed to
          safeguarding the privacy of our customers, partners, suppliers and website users.
        </p>
        <p>
          Our website is only intended for persons over the age of consent and we do not knowingly
          collect data relating to children. Please do not use our website if you are under 18
          unless your guardian has provided consent for you to do so.
        </p>
        <p>
          <strong>Data Protection Laws</strong>: Our privacy policy complies with the General Data
          Protection Regulation (EU 2016/679) (&ldquo;<strong>EU GDPR</strong>&rdquo;) as well as
          the retained EU law version of the EU GDPR (the &ldquo;<strong>UK GDPR</strong>&rdquo;)
          and the Data Protection Act 2018 (together the &ldquo;
          <strong>Data Protection Laws</strong>&rdquo;) as at the above date of our privacy policy.
        </p>
        <p>
          The Modern Builder is the data controller, as required under the Data Protection Laws in
          the UK, and in this role we are responsible for your personal data.
        </p>
        <div style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px', padding: '16px', margin: '16px 0' }}>
          <p style={{ margin: '0 0 8px 0' }}>
            <strong>Important – LeadFlow and Marketplace Services</strong>
          </p>
          <p style={{ margin: 0 }}>
            If you use our LeadFlow platform or marketplace features, additional information about
            how your personal data is used, including how it may be shared with suppliers and
            derived from planning data sources, is set out in our{' '}
            <strong>Privacy Policy Addendum (LeadFlow &amp; Marketplace Functionality)</strong>{' '}
            at the end of this document.
          </p>
        </div>
        <ul>
          <li>
            <strong>The personal data we collect about you</strong>
          </li>
        </ul>
        <p>
          Personal data means any information about an individual from which that person can be
          identified. It does not include data where the identity has been removed (anonymous data).
        </p>
        <p>
          We may collect, use, store and transfer different kinds of personal data about you which
          we have grouped together as follows:
        </p>
        <ul>
          <li>
            <strong>Identity Data</strong> includes first name, last name, username or similar
            identifier, title, your company and job title.
          </li>
          <li>
            <strong>Contact Data</strong> includes email address, telephone numbers and your postal
            address.
          </li>
          <li>
            <strong>Financial Data</strong> includes bank account and payment card details.
          </li>
          <li>
            <strong>Transaction Data</strong> includes details about payments to and from you.
          </li>
          <li>
            <strong>Technical Data</strong> includes internet protocol (IP) address, your login
            data, browser type and version, time zone setting and location, browser plug-in types
            and versions, operating system and platform, device ID and other technology on the
            devices you use to access our website.
          </li>
          <li>
            <strong>Profile Data</strong> includes your username and password, preferences, feedback
            and survey responses.
          </li>
          <li>
            <strong>Usage Data</strong> includes information about how you interact with and use our
            website and services.
          </li>
          <li>
            <strong>Communications Data </strong>includes your messages and other content sent
            through our website, email messages and telephone conversations.
          </li>
          <li>
            <strong>Marketing Data </strong>includes your preferences in receiving marketing from us
            and our third parties and your communication preferences.
          </li>
        </ul>
        <p>
          We also collect, use and share <strong>aggregated data</strong> such as statistical or
          demographic data which is not personal data as it does not directly (or indirectly) reveal
          your identity (the &lsquo;<strong>anonymous data</strong>&rsquo; referred to above). For
          example, we may aggregate individuals' Usage Data to calculate the percentage of users
          accessing a specific website feature in order to analyse general trends in how users are
          interacting with our website to help improve the website and our service offering.
        </p>
        <p>We do not collect any special category of personal data about you.</p>
        <ul>
          <li>
            <strong>How is your personal data collected?</strong>
          </li>
        </ul>
        <p>We use different methods to collect data from and about you including through:</p>
        <ul>
          <li>
            <strong>Your interactions with us.</strong> You may give us your personal data by
            filling in online forms or by corresponding with us by post, phone, email or otherwise.
            This may include personal data you provide when you:
            <ul>
              <li>use our website;</li>
              <li>apply for and/or use our services;</li>
              <li>request marketing to be sent to you;</li>
              <li>give us feedback or contact us;</li>
              <li>information you contribute to our community, including reviews; and</li>
              <li>your replies to polls and surveys.</li>
            </ul>
          </li>
          <li>
            <strong>Automated technologies or interactions.</strong> As you interact with our
            website, we will automatically collect Technical Data about your equipment, browsing
            actions and patterns to monitor how you use our website and services. We collect this
            personal data by using cookies, server logs and other similar technologies.We may also use analytics, advertising technologies, tracking pixels, and remarketing tools provided by third-party platforms to help us understand how users interact with our website, improve campaign effectiveness, and display more relevant construction and property-related advertising.These technologies may collect information relating to website interactions, browsing behaviour, device information, and campaign engagement, subject to applicable consent requirements.
          </li>
          <li>
            <strong>Third parties or publicly available sources.</strong> We may, from time to time,
            receive personal data about you from various third parties and public sources.
          </li>
          <li>
            <strong>How we use your personal data</strong>
          </li>
        </ul>
        <p>
          <em>Legal basis</em>
        </p>
        <p>
          The law requires us to have a legal basis for collecting and using your personal data. We
          rely on one or more of the following legal bases:
        </p>
        <ul>
          <li>
            <strong>Performance of a contract with you:</strong> Where we need to perform the
            contract we are about to enter into or have entered into with you.
          </li>
          {/* <li>
            <strong>Legitimate interests: </strong>We may use your personal data where it is
            necessary to conduct our business and pursue our legitimate interests, for example to
            prevent fraud and enable us to give you the best and most secure customer experience. We
            make sure we consider and balance any potential impact on you and your rights (both
            positive and negative) before we process your personal data for our legitimate
            interests. We do not use your personal data for activities where our interests are
            overridden by the impact on you (unless we have your consent or are otherwise required
            or permitted to by law).
          </li> */}
          <li>
            <strong>Legitimate interests: </strong>To improve the relevance and effectiveness of construction-related advertising, regional campaign activity, and marketing communications by using geographic information, planning activity trends, postcode-level analysis, and contextual audience segmentation. (a) Technical (b) Usage (c) Marketing and Communications (d) Profile. (a) Consent, where required for the use of cookies, tracking technologies, analytics tools, remarketing technologies, or similar advertising technologies under applicable electronic communications laws. (b) Necessary for our legitimate interests (to improve the relevance of our marketing and services, reduce irrelevant advertising, support regional campaign planning, analyse construction and development activity trends, optimise advertising performance, and support the effective operation and growth of our platform). We may retain this data for up to 24 months, after which it may be refreshed, anonymised, aggregated, or deleted where no longer required for the purposes for which it was collected.
          </li>
          <li>
            <strong>Legal obligation: </strong>We may use your personal data where it is necessary
            for compliance with a legal obligation that we are subject to. We will identify the
            relevant legal obligation when we rely on this legal basis.
          </li>
          <li>
            <strong>Consent: </strong>We rely on consent only where we have obtained your active
            agreement to use your personal data for a specified purpose, for example if you
            subscribe to an email newsletter. You have the right to withdraw consent to marketing at
            any time by sending us an email asking us to stop emailing or contacting you.
          </li>
          <li>
            <strong>Vital interests:</strong> In situations where processing personal information is
            necessary to protect someone&rsquo;s life, where consent is unable to be given and where
            other lawful bases are not appropriate, we may process personal information on the basis
            of vital interests. For example, we may inform relevant organisations if we have a
            safeguarding concern about a vulnerable person.
          </li>
        </ul>
        <p>
          <em>Purposes for which we will use your personal data</em>
        </p>
        <p>
          We have set out below, in a table format, a description of all the ways we plan to use the
          various categories of your personal data, and which of the legal bases we rely on to do
          so. We have also identified what our legitimate interests are where appropriate.
        </p>
        <table width="100%">
          <tbody>
            <tr>
              <td width="33%">
                <p>
                  <strong>Purpose/Use</strong>
                </p>
              </td>
              <td width="25%">
                <p>
                  <strong>Type of data</strong>
                </p>
              </td>
              <td width="40%">
                <p>
                  <strong>Legal basis and retention period</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td width="33%">
                <p>To register you as a new customer and to sell services to you, including:</p>
                <p>(a) verify your identity when you buy our services;</p>
                <p>(b) provide you with our services; and</p>
                <p>
                  (c) provide you with suggestions and advice and how to obtain the most benefit to
                  your business.
                </p>
              </td>
              <td width="25%">
                <p>(a) Identity</p>
                <p>(b) Contact</p>
              </td>
              <td width="40%">
                <p>Performance of a contract with you.</p>
                <p>
                  We will retain this data and continue to process this information until the
                  contract between us ends or is terminated by either party under the terms of the
                  contract.
                </p>
              </td>
            </tr>
            <tr>
              <td width="33%">
                <p>To process and deliver services including:</p>
                <p>(a) manage payments, fees and charges; and</p>
                <p>(b) collect and recover money owed to us.</p>
              </td>
              <td width="25%">
                <p>(a) Identity</p>
                <p>(b) Contact</p>
                <p>(c) Financial</p>
                <p>(d) Transaction</p>
                <p>(e) Marketing and Communications</p>
              </td>
              <td width="40%">
                <p>(a) Performance of a contract with you</p>
                <p>(b) Necessary for our legitimate interests (to recover debts due to us)</p>
                <p>We may retain this data for up to 6 years</p>
              </td>
            </tr>
            <tr>
              <td width="33%">
                <p>To manage our relationship with you which will include:</p>
                <p>(a) notifying you about changes to our terms or privacy policy; and</p>
                <p>(b) dealing with your requests, complaints and queries.</p>
              </td>
              <td width="25%">
                <p>(a) Identity</p>
                <p>(b) Contact</p>
                <p>(c) Profile</p>
                <p>(d) Marketing and Communications</p>
              </td>
              <td width="40%">
                <p>(a) Performance of a contract with you</p>
                <p>(b) Necessary to comply with a legal obligation</p>
                <p>
                  (c) Necessary for our legitimate interests (to keep our records updated and manage
                  our relationship with you
                </p>
                <p>We may retain this data for up to 6 years</p>
              </td>
            </tr>
            <tr>
              <td width="33%">
                <p>
                  To administer and protect our business and our website (including troubleshooting,
                  data analysis, testing, system maintenance, support, reporting and hosting of
                  data).
                </p>
              </td>
              <td width="25%">
                <p>(a) Identity</p>
                <p>(b) Contact</p>
                <p>(c) Technical</p>
              </td>
              <td width="40%">
                <p>
                  (a) Necessary for our legitimate interests (for running our business, provision of
                  administration and IT services, network security, to prevent fraud and in the
                  context of a business reorganisation or group restructuring exercise)
                </p>
                <p>(b) Necessary to comply with a legal obligation</p>
                <p>We may retain this data for up to 6 years.</p>
              </td>
            </tr>
            <tr>
              <td width="33%">
                <p>
                  To deliver relevant website content and online advertisements to you and measure
                  or understand the effectiveness of the advertising we serve to you.
                </p>
              </td>
              <td width="25%">
                <p>(a) Identity</p>
                <p>(b) Contact</p>
                <p>(c) Profile</p>
                <p>(d) Usage</p>
                <p>(e) Marketing and Communications</p>
                <p>(f) Technical</p>
              </td>
              <td width="40%">
                <p>
                  Necessary for our legitimate interests (to study how customers use our
                  products/services, to develop them, to grow our business and to inform our
                  marketing strategy)
                </p>
                <p>We may retain this data for up to 6 years.</p>
              </td>
            </tr>
            <tr>
              <td width="33%">
                <p>
                  To use data analytics to improve our website, services, customer relationships and
                  experiences and to measure the effectiveness of our communications and marketing.
                </p>
              </td>
              <td width="25%">
                <p>(a) Technical</p>
                <p>(b) Usage</p>
              </td>
              <td width="40%">
                <p>
                  Necessary for our legitimate interests (to define types of customers for our
                  products and services, to keep our website updated and relevant, to develop our
                  business and to inform our marketing strategy)
                </p>
                <p>We may retain this data for up to 6 years.</p>
              </td>
            </tr>
            <tr>
              <td width="33%">
                <p>
                  To send you relevant marketing communications and make personalised suggestions
                  and recommendations to you about goods, services or job opportunities that may be
                  of interest to you based on your Profile Data.
                </p>
              </td>
              <td width="25%">
                <p>(a) Identity</p>
                <p>(b) Contact</p>
                <p>(c) Technical</p>
                <p>(d) Usage</p>
                <p>(e) Profile</p>
                <p>(f) Marketing and Communications</p>
              </td>
              <td width="40%">
                <p>
                  Necessary for our legitimate interests (to carry out direct marketing, develop our
                  products/services and grow our business).
                </p>
                <p>We may retain this data for up to 6 years.</p>
              </td>
            </tr>
          </tbody>
        </table>
        <ul>
          <li>
            <strong>Direct marketing</strong>
          </li>
        </ul>
        <p>
          During the registration process on our website when your personal data is collected, you
          may be asked to indicate your preferences for receiving direct marketing communications
          from us. You may then receive marketing communications from us if you have requested
          information from us or purchased services from us and you have not opted out of receiving
          the marketing.
        </p>
        <p>
          <em>Third-party marketing</em>
        </p>
        <p>
          We will get your express consent before we share your personal data with any third party
          for their own direct marketing purposes.
        </p>
        <p>
          <em>Opting out of marketing</em>
        </p>
        <p>
          You can ask us to stop sending you marketing communications at any time by following the
          opt-out links within any marketing communication sent to you or by contacting us at
          info@themodernbuilder.co.uk.
        </p>
        <p>
          If you opt out of receiving marketing communications at any time, you will still receive
          service-related communications that are essential for administrative or customer service
          purposes.
        </p>
        <ul>
          <li>
            <strong>Disclosures of your personal data</strong>
          </li>
        </ul>
        <p>
          For the purposes set out in our privacy policy above we may share your personal data with
          the parties set out below:
        </p>
        <ul>
          <li>
            Service providers and business partners: we may share your personal data with businesses
            that provide services to us, or with business partners. As examples: we may pass your
            payment information to our payment service provider to take payments from you; or we may
            use fraud prevention agencies and credit reference agencies to verify your identity and
            we may pass your information to those agencies if we strongly suspect fraud.
          </li>
          <li>
            Where you have given us explicit permission to do so, to selected third party associates
            whom we consider may provide products or services you would find useful.
          </li>
        </ul>
        <ul>
          <li>
            Third parties to whom we may choose to sell, transfer or merge parts of our business or
            our assets. Alternatively, we may seek to acquire other businesses or merge with them.
            If a change happens to our business, then the new owners may use your personal data in
            the same way as set out in this privacy policy.
          </li>
        </ul>
        <p>
          We require all third parties to respect the security of your personal data and to treat it
          in accordance with the law. We do not allow our third-party service providers to use your
          personal data for their own purposes and only permit them to process your personal data
          for specified purposes and in accordance with our instructions.
        </p>
        <ul>
          <li>
            <strong>International transfers</strong>
          </li>
        </ul>
        <p>We do not transfer your personal data outside the UK and EU.</p>
        <ul>
          <li>
            <strong>Data security</strong>
          </li>
        </ul>
        <p>
          We have put in place appropriate security measures to prevent your personal data from
          being accidentally lost, used or accessed in an unauthorised way, altered or disclosed. In
          addition, we limit access to your personal data to those employees, agents, contractors
          and other third parties who have a business need to know. They will only process your
          personal data on our instructions and they are subject to a duty of confidentiality.
        </p>
        <ul>
          <li>
            <strong>Data retention</strong>
          </li>
        </ul>
        <p>
          Details of retention periods for different aspects of your personal data are set out in
          the table in section 4 above.
        </p>
        <p>
          Advertising, analytics, and campaign-targeting datasets are periodically reviewed and refreshed where appropriate to ensure information remains relevant and proportionate to the purposes for which it was collected.
        </p>
        <p>
          To determine the appropriate retention period for personal data, we consider the amount,
          nature and sensitivity of the personal data, the potential risk of harm from unauthorised
          use or disclosure of your personal data, the purposes for which we process your personal
          data and whether we can achieve those purposes through other means, and the applicable
          legal, regulatory, tax, accounting or other requirements.
        </p>
        <p>
          We may retain your personal data where such retention is necessary for compliance with a
          legal obligation to which we are subject, or in order to protect your vital interests or
          the vital interests of another natural person.
        </p>
        <p>
          In some circumstances you can ask us to delete your data: see section 10 below for further
          information.
        </p>
        <ul>
          <li>
            <strong>Your legal rights</strong>
          </li>
        </ul>
        <p>
          You have a number of rights under data protection laws in relation to your personal data.
          You have the right to:
        </p>
        <ul>
          <li>
            Request access to your personal data (commonly known as a "subject access request").
            This enables you to receive a copy of the personal data we hold about you and to check
            that we are lawfully processing it.
          </li>
          <li>
            Request correction of the personal data that we hold about you. This enables you to have
            any incomplete or inaccurate data we hold about you corrected, though we may need to
            verify the accuracy of the new data you provide to us.
          </li>
          <li>
            Request erasure of your personal data in certain circumstances. This enables you to ask
            us to delete or remove personal data where there is no good reason for us continuing to
            process it. You also have the right to ask us to delete or remove your personal data
            where you have successfully exercised your right to object to processing (see below),
            where we may have processed your information unlawfully or where we are required to
            erase your personal data to comply with local law. Note, however, that we may not always
            be able to comply with your request of erasure for specific legal reasons which will be
            notified to you, if applicable, at the time of your request.
          </li>
          <li>
            Object to processing of your personal data where we are relying on a legitimate interest
            (or those of a third party) as the legal basis for that particular use of your data
            (including carrying out profiling based on our legitimate interests). In some cases, we
            may demonstrate that we have compelling legitimate grounds to process your information
            which override your right to object.
          </li>
          <li>
            You also have the absolute right to object any time to the processing of your personal
            data for direct marketing purposes (see section 5 for details of how to object to
            receiving direct marketing communications).
          </li>
          <li>
            Request the transfer of your personal data to you or to a third party. We will provide
            to you, or a third party you have chosen, your personal data in a structured, commonly
            used, machine-readable format. Note that this right only applies to automated
            information which you initially provided consent for us to use or where we used the
            information to perform a contract with you.
          </li>
          <li>
            Withdraw consent at any time where we are relying on consent to process your personal
            data. However, this will not affect the lawfulness of any processing carried out before
            you withdraw your consent. If you withdraw your consent, we may not be able to provide
            certain products or services to you. We will advise you if this is the case at the time
            you withdraw your consent.
          </li>
          <li>
            Request restriction of processing of your personal data. This enables you to ask us to
            suspend the processing of your personal data in one of the following scenarios:
            <ul>
              <li>if you want us to establish the data's accuracy;</li>
              <li>where our use of the data is unlawful but you do not want us to erase it;</li>
              <li>
                where you need us to hold the data even if we no longer require it as you need it to
                establish, exercise or defend legal claims; or
              </li>
              <li>
                you have objected to our use of your data but we need to verify whether we have
                overriding legitimate grounds to use it.
              </li>
            </ul>
          </li>
        </ul>
        <p>
          If you wish to exercise any of the rights set out above, please contact us using the
          contact details in section 11.
        </p>
        <p>
          <em>No fee usually required</em>
        </p>
        <p>
          You will not have to pay a fee to access your personal data (or to exercise any of the
          other rights). However, we may charge a reasonable fee if your request is clearly
          unfounded, repetitive or excessive. Alternatively, we could refuse to comply with your
          request in these circumstances.
        </p>
        <p>
          <em>What we may need from you</em>
        </p>
        <p>
          We may need to request specific information from you to help us confirm your identity and
          ensure your right to access your personal data (or to exercise any of your other rights).
          This is a security measure to ensure that personal data is not disclosed to any person who
          has no right to receive it. We may also contact you to ask you for further information in
          relation to your request to speed up our response.
        </p>
        <p>
          <em>Time limit to respond</em>
        </p>
        <p>
          We try to respond to all legitimate requests within one month. Occasionally it could take
          us longer than a month if your request is particularly complex or you have made a number
          of requests. In this case, we will notify you and keep you updated.
        </p>
        <ul>
          <li>
            <strong>Contact details</strong>
          </li>
        </ul>
        <p>
          If you have any questions about this privacy policy or about the use of your personal data
          or you want to exercise your privacy rights, please contact us in the following ways:
        </p>
        <ul>
          <li>Email address: info@themodernbuilder.co.uk</li>
          <li>
            Postal address: 81 King Street, c/o Accounts and Legal, Manchester, England, M2 4AH
          </li>
        </ul>
        <p>
          When you contact us via any of the above methods, we collect the data you have given to us
          in order to reply with the information you need. We record your request and our reply in
          order to increase the efficiency of our business.
        </p>
        <p>
          We may keep personally identifiable information associated with your message, such as
          Identity Data, so as to be able to track our communications with you to provide a
          high-quality service.
        </p>
        <ul>
          <li>
            <strong>Complaints</strong>
          </li>
        </ul>
        <p>
          You have the right to make a complaint at any time to the Information Commissioner&rsquo;s
          Office (ICO), the UK regulator for data protection issues (www.ico.org.uk). We would,
          however, appreciate the chance to deal with your concerns before you approach the ICO so
          please contact us in the first instance.
        </p>
        <ul>
          <li>
            <strong>Changes to the privacy policy and your duty to inform us of changes</strong>
          </li>
        </ul>
        <p>
          We keep our privacy policy under regular review. It is important that the personal data we
          hold about you is accurate and current. Please keep us informed if your personal data
          changes during your relationship with us, for example a new address or email address.
        </p>
        <ul>
          <li>
            <strong>Third-party links</strong>
          </li>
        </ul>
        <p>
          Our website may include links to third-party websites, plug-ins and applications. Clicking
          on those links or enabling those connections may allow third parties to collect or share
          data about you. We do not control these third-party websites and are not responsible for
          their privacy statements. When you leave our website, we encourage you to read the privacy
          policy of every website you visit.
        </p>

        <hr style={{ margin: '32px 0', borderColor: '#dee2e6' }} />

        <center>
          <h3>PRIVACY POLICY ADDENDUM</h3>
          <p><strong>LeadFlow Platform, Planning Data &amp; Marketplace Functionality</strong></p>
        </center>

        <p><strong>1. Introduction</strong></p>
        <p>
          This Addendum forms part of the Privacy Notice of The Modern Builder Limited (&ldquo;we&rdquo;, &ldquo;us&rdquo;,
          &ldquo;our&rdquo;) and applies specifically to the use of our LeadFlow platform, marketplace services, and
          planning data integrations.
        </p>
        <p>
          This Addendum should be read alongside our main Privacy Notice. In the event of any
          inconsistency, this Addendum shall take precedence in relation to the services described herein.
        </p>

        <p><strong>2. Planning Data and Public Data Sources</strong></p>
        <p>
          We may collect and process personal data obtained from publicly available sources, including
          planning application data published by local authorities and planning data providers such as
          the Planning Portal.
        </p>
        <p>This data may include:</p>
        <ul>
          <li>applicant names</li>
          <li>site addresses</li>
          <li>planning application references</li>
          <li>project descriptions and associated documents</li>
        </ul>
        <p>We use this data to:</p>
        <ul>
          <li>identify construction and development opportunities;</li>
          <li>support users in planning and delivering projects;</li>
          <li>match users with relevant suppliers and service providers;</li>
          <li>validate or enhance information submitted by users.</li>
        </ul>
        <p>
          Where we combine publicly available data with user-provided data, this may result in the
          creation of enriched project or customer profiles.
        </p>
        <p>
          The lawful basis for this processing is our legitimate interests in operating and improving
          our platform and services.
        </p>

        <p><strong>3. Marketplace Functionality and Supplier Introductions</strong></p>
        <p>
          Our platform operates as a marketplace connecting customers (including self-builders,
          developers, and property owners) with third-party construction professionals, suppliers,
          and service providers (&ldquo;Suppliers&rdquo;).
        </p>
        <p>When you use the platform:</p>
        <ul>
          <li>
            your project details, enquiry data, and contact information may be shared with relevant
            Suppliers;
          </li>
          <li>Suppliers may access and review your information to assess your project;</li>
          <li>
            Suppliers may contact you directly using the contact details you have provided.
          </li>
        </ul>
        <p>
          Suppliers you engage with through the platform act as independent data controllers in
          respect of any personal data they receive.
        </p>
        <p>This means:</p>
        <ul>
          <li>they determine how your personal data is used once shared;</li>
          <li>their use of your data is subject to their own privacy policies.</li>
        </ul>
        <p>
          We require Suppliers to process personal data in accordance with applicable data protection
          laws.
        </p>

        <p><strong>4. Lead Generation, Matching and Profiling</strong></p>
        <p>
          We process personal data to facilitate lead generation and matching between customers and
          Suppliers.
        </p>
        <p>This includes:</p>
        <ul>
          <li>analysing project details, behaviour, and platform interactions;</li>
          <li>assessing levels of interest or readiness to engage with Suppliers;</li>
          <li>prioritising or recommending projects to Suppliers;</li>
          <li>improving the relevance of supplier matches.</li>
        </ul>
        <p>This may involve automated processing and profiling.</p>
        <p>
          We do not carry out solely automated decision-making that produces legal or similarly
          significant effects.
        </p>
        <p>
          The lawful basis for this processing is our legitimate interests in operating an efficient
          and effective marketplace.
        </p>

        <p><strong>5. Platform Messaging and Communications</strong></p>
        <p>Our platform enables communication between users and Suppliers.</p>
        <p>When using messaging features:</p>
        <ul>
          <li>messages may be stored and processed by us;</li>
          <li>
            messages may be accessible to the relevant Supplier(s) involved in the conversation;
          </li>
          <li>
            communications may be used to support service delivery, quality assurance, and platform
            improvements.
          </li>
        </ul>
        <p>We may monitor communications where reasonably necessary for:</p>
        <ul>
          <li>security purposes;</li>
          <li>fraud prevention;</li>
          <li>compliance with our terms and policies.</li>
        </ul>

        <p><strong>6. Supplier Communications</strong></p>
        <p>As part of the core service provided by our platform:</p>
        <ul>
          <li>
            Suppliers may contact you directly in relation to your project or enquiry;
          </li>
          <li>such communications are considered part of the service you have requested.</li>
        </ul>
        <p>
          These communications are distinct from general marketing and are necessary to facilitate
          connections between customers and Suppliers.
        </p>

        <p><strong>7. Data Sharing and Responsibility</strong></p>
        <p>Where personal data is shared with Suppliers:</p>
        <ul>
          <li>we act as the data controller up to the point of sharing;</li>
          <li>Suppliers act as independent data controllers thereafter.</li>
        </ul>
        <p>
          We take reasonable steps to ensure that data is only shared where necessary and appropriate
          safeguards are in place.
        </p>
        <p>
          However, we are not responsible for how Suppliers use personal data once they receive it.
        </p>

        <p><strong>8. Lawful Basis Summary</strong></p>
        <p>Processing under this Addendum is primarily based on:</p>
        <ul>
          <li>
            <strong>Legitimate interests</strong> – operating the platform, matching users and
            Suppliers, analysing planning data;
          </li>
          <li>
            <strong>Contractual necessity</strong> – delivering services requested by users;
          </li>
          <li>
            <strong>Consent</strong> – where required for marketing communications.
          </li>
        </ul>
        <p>
          We ensure that our legitimate interests are balanced against your rights and freedoms.
        </p>

        <p><strong>9. Updates to this Addendum</strong></p>
        <p>
          We may update this Addendum from time to time to reflect changes to our platform, services,
          or legal obligations.
        </p>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default CustomPrivacyPolicyPage;
